import * as React from 'react';
import * as ReactDOM from 'react-dom';
import ContentsRootComponent from './contents-root-component';


ReactDOM.render(
    <ContentsRootComponent />
, document.getElementById('root'));


if (module["hot"]) {
    module["hot"].accept()
}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/contents/index.tsx